/**
 * ambassadorStore — controla os overlays do programa de recomendação (Zustand): o convite de
 * adesão (OptInDialog, com o motivo "survey" quando vem de uma nota alta) e o modal de
 * compartilhamento de conteúdo (showShareButtons). Cada um abre por cima da tela atual.
 */
import { create } from 'zustand';

/** Contexto do modal de compartilhamento: link do embaixador ou vídeo de conteúdo. */
export type ShareContext =
  | { kind: 'ambassador'; slug: string; discount: number }
  | { kind: 'content'; format: 'leadtalk' | 'leadmusic'; videoId: string; title: string };

export type OptInReason = 'survey' | null;

interface AmbassadorState {
  optInOpen: boolean;
  optInReason: OptInReason;
  share: ShareContext | null;
  openOptIn: (reason?: OptInReason) => void;
  closeOptIn: () => void;
  openShare: (ctx: ShareContext) => void;
  closeShare: () => void;
}

export const useAmbassadorStore = create<AmbassadorState>((set) => ({
  optInOpen: false,
  optInReason: null,
  share: null,
  openOptIn: (reason = null) => set({ optInOpen: true, optInReason: reason }),
  closeOptIn: () => set({ optInOpen: false, optInReason: null }),
  openShare: (ctx) => set({ share: ctx }),
  closeShare: () => set({ share: null }),
}));
